import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from './style'


const RemoveCommentModal = ({ closeModal, confirmRemove }) => {

  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage id="removeModal" />
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default RemoveCommentModal
